import queryString from "query-string"
import { parseLocationFromResponse } from '../utils/findLocation';

const monsterAdapter = {
  formatParams(params = {}) {


    const locationParams = {};

    
    if (params.location) {
   
      if (typeof params.location === 'string') {
       
        if (/^\d+$/.test(params.location)) {
          
          locationParams.rlid = params.location;
        } else {
   
          locationParams.rloc = params.location;
        }
      } else if (typeof params.location === 'number') {
  
        locationParams.rlid = String(params.location);
      } else if (typeof params.location === 'object') {
 
        if (params.location.locationId) {
         
          locationParams.rlid = String(params.location.locationId);
     
        } else if (params.location.id) {
          locationParams.rlid = String(params.location.id);
        } else if (params.location.name) {
        
          locationParams.rloc = params.location.name;
        }
      }
    }

 
    const radius = params.radius || '30'; 

   
    if (params.postalCode) {

      locationParams.rpcr = `${params.postalCode}-${radius}`;
    } else if (locationParams.rlid || locationParams.rloc) {
    
      locationParams.rad = radius;
    } else {
     
      locationParams.rad = radius;
    }

   
    if (params.targetWorkLocation) {

   
      if (typeof params.targetWorkLocation === 'string') {
        
        if (/^\d+$/.test(params.targetWorkLocation)) {
         
          locationParams.twlid = params.targetWorkLocation;
        } else {
         
          locationParams.twloc = params.targetWorkLocation;
        }
      } else if (typeof params.targetWorkLocation === 'number') {
        locationParams.twlid = String(params.targetWorkLocation);
      } else if (typeof params.targetWorkLocation === 'object') {
       
        if (params.targetWorkLocation.locationId) {
         
          locationParams.twlid = String(params.targetWorkLocation.locationId);
        } else if (params.targetWorkLocation.id) {
          locationParams.twlid = String(params.targetWorkLocation.id);
        } else if (params.targetWorkLocation.name) {
        
          locationParams.twloc = params.targetWorkLocation.name;
        }
      }
    }



    const formattedParams = {
      q: params.keyword || "",
      qb: params.keywordBehavior || "And",
      qrjt: params.jobTitle || "",
      qtjt: params.targetJobTitle || "",
      qrcn: params.recentCompany || "",
      qrjd: params.recentJobDescription || "",
      qsn: params.schoolName || "",
      ...locationParams,
      twlb: params.targetWorkLocationBoolean,
      twsite: params.targetWorkSite,
      edulv: params?.education?.length ? params.education.join("+") : undefined,
      edumjr: params.educationMajor || undefined,
      yrsexpid: params.experience?.length ? params.experience.join(",") : undefined,
      tjtft: params.jobType?.includes("Full Time") ? '1' : undefined,
      tjtpt: params.jobType?.includes("Part Time") ? '1' : undefined,
      tjttc: params.jobType?.includes("Contract") ? '1' : undefined,
      tjti: params.jobType?.includes("Intern") ? '1' : undefined,
      tjtpd: params.jobType?.includes("Per Diem") ? '1' : undefined,
      tjts: params.jobType?.includes("Seasonal") ? '1' : undefined,
      clv: params.careerLevel?.length ? params.careerLevel.join(",") : undefined,
      wa: params.workAuthorization?.length ? params.workAuthorization.join(",") : undefined,
      relo: params.willingToRelocate ? '1' : '0',
      mdatemaxage: params.updatedWithin || undefined,
      tsalmin: params.salary?.min || undefined,
      tsalmax: params.salary?.max || undefined,
      tsalcur: params.salary?.currency || undefined,
      tsaltyp: params.salary?.type || undefined,
      tnsalmin: params.salary?.normalizedMin || undefined,
      tnsalmax: params.salary?.normalizedMax || undefined,
      tsni: params.salary?.includeSalaryNotSpecified ? '1' : undefined,
      gsc: params.securityClearance?.length ? params.securityClearance.join(",") : undefined,
      mgrex: params.managerialExperience ? '1' : undefined,
      projld: params.projectLeadership ? '1' : undefined,
      twindus: params.targetIndustry?.length ? params.targetIndustry.join(",") : undefined,
      indus: params.industry?.length ? params.industry.join(",") : undefined,
      lskill: params.languageSkills?.map(skill => `${skill.language}-${skill.proficiency}`).join(",") || undefined,
      rslang: params.resumeLanguage || undefined,
      gmi: params.militaryStatus?.length ? params.militaryStatus.join(",") : undefined,
      sort: params.sortBy || "mdate",
      page: params.page || "1",
      pageSize: params.pageSize || "20",
    };


    Object.keys(formattedParams).forEach((key) => formattedParams[key] === undefined && delete formattedParams[key]);

    return queryString.stringify(formattedParams);
  },

  parseResults: (data) => {
    try {


   
      if (!data) {

        return { results: [], total: 0 };
      }

    
      let monsterData;
      let totalResults = 0;

      const extractTotalResults = (obj) => {
        if (obj && obj.$ && obj.$.Found) {
          return parseInt(obj.$.Found, 10) || 0;
        }
        return 0;
      };

      
      if (data.data && data.data.candidates && data.data.totalCount !== undefined) {

        monsterData = { Resume: data.data.candidates };
        totalResults = parseInt(data.data.totalCount, 10) || 0;
      } else if (data.candidates && data.totalCount !== undefined) {

        monsterData = { Resume: data.candidates };
        totalResults = parseInt(data.totalCount, 10) || 0;
      } else if (data.Monster && data.Monster.Resumes && data.Monster.Resumes.length > 0) {
        monsterData = data.Monster.Resumes[0];
        totalResults = extractTotalResults(data.Monster.Resumes[0]);
      } else if (Array.isArray(data) && data.length > 0 && data[0].$ && data[0].Resume) {

        monsterData = data[0];
        totalResults = extractTotalResults(data[0]);
      } else if (data.data && data.data.Monster && data.data.Monster.Resumes) {

        monsterData = data.data.Monster.Resumes[0];
        totalResults = extractTotalResults(data.data.Monster.Resumes[0]);
      } else if (data.results) {

        return data;
      } else {
        console.warn('Unexpected data format:', data);

        const possibleResumeData = findResumeData(data);
        if (possibleResumeData) {
          monsterData = { Resume: possibleResumeData };
        } else {
          console.error('Could not find resume data in response');
          return { results: [], total: 0 };
        }
      }


      if (!monsterData?.Resume?.length) {
        return { results: [], total: 0 };
      }

      const results = monsterData.Resume.map((resume) => {
        try {
          const parsedLocation = parseLocationFromResponse(resume?.PersonalData?.[0]?.Address?.[0]);

          const target = resume?.Target?.[0] || {};
          const targetSalary = target?.Salary?.[0] || {};
          const relocation = target?.Relocation?.[0];

          const experiences = resume?.Experiences?.[0]?.Experience || [];
          const currentPosition = experiences[0] ? {
            title: experiences[0]?.Job?.[0]?.Title?.[0] || '',
            company: experiences[0]?.Company?.[0]?.Name?.[0] || '',
            description: experiences[0]?.Job?.[0]?.Description?.[0] || '',
            dateFrom: experiences[0]?.DateFrom?.[0]?.$,
            dateTo: experiences[0]?.DateTo?.[0]?.$ || 'Present'
          } : null;

          const previousPosition = experiences[1] ? {
            title: experiences[1]?.Job?.[0]?.Title?.[0] || '',
            company: experiences[1]?.Company?.[0]?.Name?.[0] || '',
            description: experiences[1]?.Job?.[0]?.Description?.[0] || '',
            dateFrom: experiences[1]?.DateFrom?.[0]?.$,
            dateTo: experiences[1]?.DateTo?.[0]?.$ || ''
          } : null;

          const candidateId = resume?.$?.SID || resume?.candidateId || null;
          if (!candidateId) {
            console.warn('Resume missing SID:', resume);
            return null;
          }

          return {
            id: candidateId,
            candidateId: resume?.candidateId || '',
            name: resume?.PersonalData?.[0]?.Confidential?.[0] === '1'
              ? 'Confidential'
              : `${resume?.PersonalData?.[0]?.Name?.[0]?.First?.[0] || ''} ${resume?.PersonalData?.[0]?.Name?.[0]?.Last?.[0] || ''}`.trim() || 'Anonymous',
            resumeTitle: resume?.ResumeTitle?.[0] || '',
            location: parsedLocation?.fullName || resume?.PersonalData?.[0]?.Address?.[0]?.Location?.[0] || 'Location not specified',
            locationDetails: {
              ...parsedLocation,
              postalCode: resume?.PersonalData?.[0]?.Address?.[0]?.PostalCode?.[0] || '',
              city: resume?.PersonalData?.[0]?.Address?.[0]?.City?.[0] || '',
              state: resume?.PersonalData?.[0]?.Address?.[0]?.State?.[0]?.$?.LID || '',
              country: resume?.PersonalData?.[0]?.Address?.[0]?.Country?.[0]?.$?.LID || '',
            },
            dateModified: resume?.DateModified?.[0]?.$?.Date || null,
            dateCreated: resume?.DateCreated?.[0]?.$?.Date || null,
            currentPosition,
            previousPosition,
            metadata: {
              smsOptIn: false,
              isVeteran: resume?.PersonalData?.[0]?.MilitaryExperience?.[0]?.ServiceFlag?.[0] === "1",
              isDiversity: false,
              militaryInvolvement: resume?.PersonalData?.[0]?.MilitaryExperience?.[0]?.MilitaryInvolvement?.[0] || null
            },
            isConfidential: resume?.PersonalData?.[0]?.Confidential?.[0] === "1",
            targetInfo: {
              jobTitle: target?.JobTitle?.[0] || '',
              relocation: {
                willing: relocation?.$?.ID !== "0",
                status: relocation?._ || "Not Specified"
              },
              salary: {
                min: targetSalary?.Min?.[0] || '',
                max: targetSalary?.Max?.[0] || '',
                type: targetSalary?.Type?.[0]?.$?.ID || '',
                currency: targetSalary?.Currency?.[0]?.$?.ID || ''
              },
              jobTypes: (() => {
                if (Array.isArray(target?.JobTypes)) {
                  return target.JobTypes.filter(Boolean);
                }

                if (typeof target?.JobTypes?.[0] === 'string') {
                  return target.JobTypes[0].split(',').filter(Boolean);
                }

                if (Array.isArray(target?.JobTypes?.[0]?.JobType)) {
                  return target.JobTypes[0].JobType.map(job => {
                    if (job && typeof job === 'object' && job._) {
                      return job._;
                    }
                    return typeof job === 'string' ? job : null;
                  }).filter(Boolean);
                }

                return [];
              })()
            },
            isViewed: Boolean(resume?.isViewed),
            education: resume?.Educations?.[0]?.Education?.[0]?.Level?.[0]?._ || '',
            workAuth: {
              type: resume?.WorkAuths?.[0]?.WorkAuth?.[0]?.AuthType?.[0]?._ || '',
              country: resume?.WorkAuths?.[0]?.WorkAuth?.[0]?.Country?.[0]?._ || ''
            },
            relevance: parseFloat(resume?.Relevance?.[0]) || 0,
            board: resume?.Boards?.[0]?.Board?.[0]?._ || '',
            attachments: resume?.attachments || [],
            viewHistory: Array.isArray(resume?.viewedHist) ? resume.viewedHist : [],
            notesInfo: (() => {
              try {

                if (resume.notesInfo && typeof resume.notesInfo === 'object') {
                 
                  const parsedNotesInfo = {
                    hasNotes: Boolean(resume.notesInfo.hasNotes),
                    notesCount: typeof resume.notesInfo.notesCount === 'number' ? resume.notesInfo.notesCount :
                      resume.notesInfo.notes?.length || 0,
                    notes: Array.isArray(resume.notesInfo.notes) ? resume.notesInfo.notes : [],
                    fromPending: Boolean(resume.notesInfo.fromPending)
                  };
                  return parsedNotesInfo;
                }

                if (resume.notes && Array.isArray(resume.notes)) {
                  return {
                    hasNotes: resume.notes.length > 0,
                    notesCount: resume.notes.length,
                    notes: resume.notes,
                    fromPending: resume.notesFromPending || resume.fromPending || true
                  };
                }

                if (resume.notesCount && !isNaN(resume.notesCount) && parseInt(resume.notesCount) > 0) {
                  
                  return {
                    hasNotes: true,
                    notesCount: parseInt(resume.notesCount),
                    notes: [],
                    fromPending: resume.notesFromPending || resume.fromPending || true
                  };
                }

                return {
                  hasNotes: false,
                  notesCount: 0,
                  notes: [],
                  fromPending: false
                };
              } catch (error) {
                return {
                  hasNotes: false,
                  notesCount: 0,
                  notes: [],
                  fromPending: false
                };
              }
            })()
          };
        } catch (error) {
          console.error('Error parsing resume:', error, resume);
          return null;
        }
      }).filter(Boolean);

      return {
        results,
        total: totalResults || results.length
      };
    } catch (error) {
      console.error('Error in monsterAdapter.parseResults:', error);
      return { results: [], total: 0 };
    }
  }
};


function findResumeData(data) {

  if (!data) return null;


  if (Array.isArray(data)) {
    return data;
  }


  for (const key in data) {
    if (key === 'Resume' && Array.isArray(data[key])) {
      return data[key];
    }

   
    if (typeof data[key] === 'object' && data[key] !== null) {
      const nestedResult = findResumeData(data[key]);
      if (nestedResult) return nestedResult;
    }
  }

  return null;
}

export default monsterAdapter;

